import React, {useEffect, useState} from 'react';
import Typography from "@mui/material/Typography";
import {ButtonStyled} from "../styledComponent/styledComponents";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Box from "@mui/material/Box";
import {timeConverter} from "../../utils/data";
import {useGetAccreditationResendOtpMutation} from "../../features/apiSlice/accreditation-otp"
import {useModal, ModalIds} from "../../contexts/ModalContext"
import {toast} from "react-toastify";

const TimerCounter = ({counter}) => {
    const [resendOtp, {data: resendOtpData, isLoading, error, isFetching}] = useGetAccreditationResendOtpMutation()
    const [resendCounter, setResendCounter] = useState(undefined)

    const handleResendOtp = () => {
        resendOtp()
            .unwrap()
            .then(res => {
                setResendCounter(prev => res?.data?.resendWait)
            })
            .catch(err => toast.error(err.message))
    }

    useEffect(() => {
        if (resendCounter > 0) {
            setTimeout(() => {
                setResendCounter((resendCounter) => resendCounter - 1);
            }, 1000)
        }
    }, [resendCounter])

    return (
        <div>
            {
                (counter > 0 || resendCounter > 0) ?
                    <Box>
                        <Typography color={"fourth.main"} mb={2}>
                            {timeConverter(counter > 0 ? counter : resendCounter)}
                        </Typography>
                    </Box>
                    :
                    <ButtonStyled
                        onClick={handleResendOtp}
                        width={144} height={48} color={'secondary'}
                        startIcon={<AutorenewIcon sx={{transform: "rotate(70deg)"}}/>} variant="contained">
                        ارسال مجدد
                    </ButtonStyled>
            }
        </div>
    )
};

export default TimerCounter;